﻿import {
    StateActionTypes,
    ParagraferState,
    SET_PARAGRAFER,
    UPDATE_PARAGRAFER,
    SET_FEILMELDING,
} from './Types';
import { ParagrafViewModel } from '../Models/ResultViewModel';

export const initialState: ParagraferState = {
    paragrafer: new Array<ParagrafViewModel>(),
    sisteAktiveLamell: undefined,
    loading: true,
    firstLoadReady: false,
    modalOpen: undefined,
    kapittelMerknadOverskrift: undefined,
    kapittelMerknadTekst: undefined,
    kapittelMerknadLenketekst: undefined,
    visFeilmelding: false,
}

export function paragraferReducer(
    state: ParagraferState = initialState,
    action: StateActionTypes
): ParagraferState  {
    const newState = getNewState();
    return newState;

    function getNewState(): ParagraferState {
        switch (action.type) {
            case SET_FEILMELDING:
                return {
                    ...action.payload,
                    loading: false,
                    visFeilmelding: true,
                }
            case SET_PARAGRAFER:
                return {
                    ...action.payload,
                    loading: false,
                    firstLoadReady: true,
                };
            case UPDATE_PARAGRAFER:
                return {
                    ...action.payload,
                    loading: false,                 
                };
            default:
                return state;
        }
    }
}
